module.exports = __webpack_public_path__ + "static/media/icon-module-audit-management-desktop.324acd74.svg";